import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { ERROR_GET_WA_TEMPLATES_SERVER } from '@/app/module/content/definitions'
import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export type WaTemplatesQuery = {
  approved?: boolean
  register?: boolean
}

export const useGetWaTemplates = ({ approved, register }: WaTemplatesQuery) => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const res = esApi.endpoints.getOrgWaTemplatesList.useQuery({
    orgId: orgId.toString(),
    approved: approved?.toString(),
    register: register?.toString(),
  })

  useEffect(() => {
    if (!res.error) {
      return
    }
    dispatch(
      createNotification({
        'get-wa-templates': {
          type: 'error',
          message: getErrorMessage(res.error, ERROR_GET_WA_TEMPLATES_SERVER),
        },
      }),
    )
  }, [res.error, dispatch])

  return res
}
